import BaseService from './baseService';

class Jadwal extends BaseService {
	async getJadwal(opts = {}) {
    this.endPoint = '/schedule';
		return this.get(opts);
  }
  async createJadwal(payload){
    this.endPoint = '/schedule';
    return await this.post(payload); 
  }
  async cekJadwal(payload){
    this.endPoint = '/schedule/cek';
    return await this.post(payload); 
  }
  async updateJadwal(id,payload,opts={}){
    this.endPoint = '/schedule';
    return await this.putOne(id,payload,opts);
  }
  async deleteJadwal(id,opts={}){
    this.endPoint = '/submission';
    return await this.delete(id,opts);
  }
}

export default new Jadwal();